import { useState } from 'react';
import { getSafeKey } from '../utils/namedLocalStorage';

export const useLocalStorage = (key: string, initialValue?: any) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const safeKey = getSafeKey(key);
      const item = window.localStorage.getItem(safeKey);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      // eslint-disable-next-line
      console.log(error);
      return initialValue;
    }
  });

  /* Return a wrapped version of useState's setter function that
   * persists the new value to localStorage.
   */
  const setValue = (value: any) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      const safeKey = getSafeKey(key);
      window.localStorage.setItem(safeKey, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      // eslint-disable-next-line
      console.log(error);
    }
  };

  return [storedValue, setValue];
};
